import React, {useEffect, useState} from 'react';
import { getHeaderData } from "common/Header/store/actionCreators";
import { useSelector,useDispatch } from 'react-redux';
import {Container} from "./style";
import {Image, ImageViewer, Button, Space, Toast,Dialog} from "antd-mobile";
import {List,Badge} from "antd";
import $axios from "../../request";
import Header from "../../common/Header";
import Aliplayer from "aliplayer-react";
import {isNotBlank} from "../../util/StringUtil";
import {getUserInfoData} from "../../common/User/store/actionCreators";
import moment from "moment";
import {getActivityData, setActivitySelectData} from "../../common/VoteActivity/store/actionCreators";
import AudioPlay from "../AudioPlay";
//路由
import {
    Link,useHistory
} from "react-router-dom";

export default function CreationDetail(props){
    let history = useHistory();
    const dispatch = useDispatch();
    const  user  = useSelector((state) => state.getIn(['user', 'userInfo']));
    const  isLoginError  = useSelector((state) => state.getIn(['user', 'isLoginError']));
    const  activity  = useSelector((state) => state.getIn(['activity', 'activitySelect']));
    const  headerData  = useSelector((state) => state.getIn(['header', 'headerData']));
    const [vid, setVid] = useState('');
    const [imgPath, setImgPath] = useState([]);
    const [audioPath, setAudioPath] = useState(null);
    const [loading, setLoading] = useState(false);
    const [creationDetail, setCreationDetail] = useState(null);
    const [playAuth, setPlayAuth] = useState('');
    const [instance, setInstance] = useState(null);
    const [todayVoteCount, setTodayVoteCount] = useState(0);
    const [config, setConfig] = useState({});

    if(isLoginError){
        props.history.push('/login');
    }

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        if(!creationDetail){
            getCreationDetail();
        }

        dispatch(getHeaderData({
                title: creationDetail?.title||'',
                type: 0,
                rightType: 0,
                rightFun: {},
                path: '/main/'+activity?.id
            }))

        if(user=== null||user === undefined){
            dispatch( getUserInfoData())
        }else{
            getTodayVoteCount();
        }


    }, [dispatch,user,creationDetail,activity]);

    function getTodayVoteCount(){
        let url = '/vote/record/today/count';
        let data = {userId:user.id};
        $axios.postRequest(url, data)
            .then((response) => {
                console.log(url, response);
                let { errcode,data } = response
                if (response && response.succeed) {
                    setTodayVoteCount(data);
                }


            })
            .catch((error) => {
                console.log(url, error);

            });
    }

    //获取活动详情
    function getActivityDetail(activityId){
        let url = '/vote/activity/findById';
        let data = {id:activityId};
        $axios.postRequest(url, data)
            .then((response) => {
                console.log(url, response);
                let { errcode,data } = response
                if (response && response.succeed) {
                    dispatch(setActivitySelectData(data));
                }


            })
            .catch((error) => {
                console.log(url, error);

            });
    }
    //获取作品详情
    function getCreationDetail(){
        let url = '/vote/creation/findById';
        let data = {id:props.match.params.creationId};
        $axios.postRequest(url, data)
            .then((response) => {
                console.log(url, response);

                let { errcode,data } = response
                if (response && response.succeed) {


                    setCreationDetail(data);
                    if(isNotBlank(data.vodId)){
                        setVid(data.vodId);
                        getPlayauth(data.vodId);
                    }
                    if(isNotBlank(data.imgPathShow)){
                        setImgPath(data.imgPathShow.toImg());
                    }
                    if(isNotBlank(data.audioPath)){
                        setAudioPath(data.audioPath.toImg());
                    }

                    if(isNotBlank(data.activityId)){
                       if(activity===null||activity===undefined||(activity!==null&&activity.id !=data.activityId)){
                           getActivityDetail(data.activityId);
                       }
                    }
                    dispatch(getHeaderData({
                        title: data.title,
                        type: 0,
                        rightType: 0,
                        rightFun: {},
                        path: headerData.get('path')||''
                    })) ;

                }


            })
            .catch((error) => {
                console.log(url, error);

            });
    }

    //获取播放凭证
    function getPlayauth(vodId){
     //   console.log("getPlayauth vid=",vid)
        let url = '/vod/getVideoPlayAuth';
        let data = {videoId:vid||vodId};
        $axios.postRequest(url, data)
            .then((response) => {
                console.log(url, response);

                let { errcode, } = response
                if (response && response.succeed) {
                    console.log("getPlayauth vid2=",response.data.playAuth)
                    setConfig({
                        width: "100%",
                        minHeight: "100px",
                        autoplay: false,
                        preload: true,
                        rePlay: true,// 播放器自动循环播放
                        playsinline: true,//H5是否内置播放，有的Android浏览器不起作用。
                        vid : vid||vodId,
                        accessKeyId: 'LTAI4GAhT6DCnDNySHus1B8s',
                        accessKeySecret: 'Ah0PeUqFiKt0RZ4Pk3BFNjElT2TcFy',
                        securityToken: response.data.playAuth,
                        region: 'cn-shanghai', // eu-central-1, ap-southeast-1,
                        // source:"//player.alicdn.com/video/aliyunmedia.mp4",
                        qualitySort: "asc",
                        format: "m3u8",
                        mediaType: "video",
                        isLive: false,
                        controlBarVisibility: "hover",
                        useH5Prism: true,
                    });
                    setPlayAuth(response.data.playAuth);

                }


            })
            .catch((error) => {
                console.log(url, error);

            });
    }
    function dateFormat(dateParam){

        return moment(parseInt(dateParam)).format('YYYY年MM月DD日');
    }

    function handleFun(to) {
        to+='?&time='+Date.parse(new Date())
        history.push(to)

    }

    /**
     * 投票
     */
    function voteSubmit(){
        setLoading(true);
        let url = '/vote/creation/app/likeYou';
        let data = {id:creationDetail.id,userId:user.id};
        $axios.postRequest(url, data)
            .then((response) => {
                console.log(url, response);
                let { errcode,data } = response
                if (response && response.succeed) {
                    getTodayVoteCount();
                    setLoading(false);
                    if(window.ReactNativeWebView) {
                        if(user.userTypeEnum?.name ==='ORDINARY'){
                            Toast.show({
                                icon: 'success',
                                content: '投票成功',
                            })
                        }else{
                            const handlerDialog =   Dialog.show({
                                content: '投票成功,获得一次抽奖机会',
                                closeOnAction: true,
                                actions: [
                                    {
                                        key: 'cancel',
                                        text: '继续投票',

                                    },
                                    {
                                        key: 'lottery',
                                        text: '去抽奖',
                                        bold: true,
                                        onClick:()=>{
                                            if(window.ReactNativeWebView) {
                                                window.ReactNativeWebView.postMessage("openLotteryPage")
                                            }else{
                                                dispatch(getHeaderData({
                                                    title:'抽奖',
                                                    type: 0,
                                                    rightType: 0,
                                                    rightFun: {},
                                                    path: '/creationDetail/'+creationDetail?.id
                                                }))
                                                handleFun('/iframe/lotteryPage')
                                            }
                                        }
                                    }
                                ],
                            })
                        }

                    }else{
                        Toast.show({
                            icon: 'success',
                            content: '投票成功',
                        })
                    }


                }else{
                    setLoading(false);
                }


            })
            .catch((error) => {
                console.log(url, error);
                setLoading(false);
            });
    }

    return (

        <Container>
            <div className="container">
                <div>
                    <Header history={props.history} />
                </div>

                {
                    // 视频展示
                    activity?.voteTypeEnum?.name==='VIDEO'&&playAuth&&<Aliplayer
                        config={config}
                        onGetInstance={instance => setInstance(instance)}
                    />
                }
                {
                    // 音频展示
                    activity?.voteTypeEnum?.name==='AUDIO'&&audioPath&&<AudioPlay
                        src={
                            audioPath
                        }
                        id={creationDetail?.id}
                    />
                }
                <Space direction='vertical' style={{ '--gap': '24px' }}>
                {
                    // 图片展示
                    activity?.voteTypeEnum?.name==='IMG'&&imgPath&&imgPath.map((item, index) => {
                        return<Image lazy={true} src={imgPath[index]} width={'100%'}  fit='fill' onClick={
                            () => { ImageViewer.Multi.show({images:imgPath,defaultIndex:index})}
                        }/>
                    })
                }

                </Space>
                {
                    creationDetail&& <div >

                            <div  className="title">
                                作品名称
                            </div>
                            <div  className="desc">
                                {
                                    creationDetail.title
                                }
                            </div>

                            <div  className="title">
                                作者
                            </div>
                            <div  className="desc">
                                {
                                    creationDetail.userName||'未公开'
                                }
                            </div>
                            <div  className="title">
                                作者单位
                            </div>
                            <div  className="desc">
                                {
                                    creationDetail.companyName||'未公开'
                                }
                            </div>

                        {
                            creationDetail.shootingTime&&creationDetail.shootingPlace&&creationDetail.shootingDevice&&<div>
                                <div  className="title">
                                    作品信息
                                </div>
                                <div  className="desc">
                                    <div>
                                        拍摄时间:
                                        {
                                            creationDetail.shootingTime&&dateFormat(creationDetail.shootingTime)||'无'
                                        }
                                    </div>

                                    <div>
                                        拍摄地点:
                                        {
                                            creationDetail.shootingPlace||'无'
                                        }
                                    </div>

                                    <div> 拍摄设备:
                                        {
                                            creationDetail.shootingDevice||'无'
                                        }

                                    </div>

                                </div>
                            </div>
                        }

                            <div  className="title">
                                作品简介
                            </div>
                            <div  className="desc">
                                {
                                    creationDetail.description||'无'
                                }
                            </div>
                        {
                            activity?.voteState&&<div  className="voteBtn">
                                <Button block color='primary' loading={loading} disabled={activity?.voteCount-todayVoteCount<=0} onClick={()=>{voteSubmit()}} >
                                    投票
                                </Button>
                                {
                                    activity&& <div className="voteBtnText">
                                        今日剩余投票次数:
                                        {
                                            (activity?.voteCount-todayVoteCount)||0
                                        }
                                        次
                                    </div>
                                }


                            </div>
                        }

                        {
                            activity?.voteState&&window.ReactNativeWebView&&user.userTypeEnum?.name !=='ORDINARY'&&<Image  src={'https://zhihuigonghui.oss-cn-beijing.aliyuncs.com/images/3661638406077_.pic_hd.jpg'} width={'100%'}  fit='fill' onClick={
                                () => {
                                    if(window.ReactNativeWebView) {
                                        window.ReactNativeWebView.postMessage("openLotteryPage")
                                    }else{
                                        dispatch(getHeaderData({
                                            title:'抽奖',
                                            type: 0,
                                            rightType: 0,
                                            rightFun: {},
                                            path: '/creationDetail/'+creationDetail?.id
                                        }))
                                        handleFun('/iframe/lotteryPage');
                                    }
                                }}/>
                        }


                    </div>
                }

            </div>



        </Container>
    )


}
